import "core-js/modules/es.array.reverse";
import "core-js/modules/es.array.slice";
import "core-js/modules/esnext.reflect.metadata";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { IsMongoId, IsOptional, IsString } from 'class-validator';
export var AppDto = (_dec = IsMongoId(), _dec2 = Reflect.metadata("design:type", String), _dec3 = IsMongoId(), _dec4 = Reflect.metadata("design:type", String), _dec5 = IsString(), _dec6 = Reflect.metadata("design:type", String), _dec7 = IsOptional(), _dec8 = IsString(), _dec9 = Reflect.metadata("design:type", String), _dec10 = IsString({
  each: true
}), _dec11 = Reflect.metadata("design:type", Array), _dec12 = IsOptional(), _dec13 = IsString(), _dec14 = Reflect.metadata("design:type", String), _dec15 = IsOptional(), _dec16 = IsString(), _dec17 = Reflect.metadata("design:type", String), (_class = (_temp = class AppDto {
  constructor() {
    _initializerDefineProperty(this, "user_id", _descriptor, this);

    _initializerDefineProperty(this, "app_id", _descriptor2, this);

    _initializerDefineProperty(this, "app_name", _descriptor3, this);

    _initializerDefineProperty(this, "app_icon", _descriptor4, this);

    _initializerDefineProperty(this, "redirect_uris", _descriptor5, this);

    _initializerDefineProperty(this, "approve_uri", _descriptor6, this);

    _initializerDefineProperty(this, "consent_uri", _descriptor7, this);
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "user_id", [_dec, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "app_id", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "app_name", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "app_icon", [_dec7, _dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "redirect_uris", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "approve_uri", [_dec12, _dec13, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "consent_uri", [_dec15, _dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));